module.exports = __webpack_public_path__ + "img/eastspring.2ad44e37.png";